import { render, staticRenderFns } from "./staffGl.vue?vue&type=template&id=7d2f1ea4&scoped=true&"
import script from "./staffGl.vue?vue&type=script&lang=js&"
export * from "./staffGl.vue?vue&type=script&lang=js&"
import style0 from "./staffGl.vue?vue&type=style&index=0&id=7d2f1ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f1ea4",
  null
  
)

export default component.exports